import { useSelector } from "react-redux";
// import { useGetOrderedProductsQuery } from "../store/apiSlice";
import EditEmployerProfile1 from "./EditEmployerProfile1";

function EmployersCenter() {
  const employer = useSelector((state) => state.posts.employer);

  return (
    <div className="w-full flex flex-col mt-2">

      <div className="w-full flex justify-between">
        <div className="w-full">
          <EditEmployerProfile1 id={employer?.employer_id} />
        </div>

      </div>
    </div>
  );
}
export default EmployersCenter;
